// extracted by mini-css-extract-plugin
export default {"InputVerify":"Code_InputVerify__L7CQy","Input":"Code_Input__NC4At"};